/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Point } from './';
import {
    PointFromJSON,
    PointFromJSONTyped,
    PointToJSON,
} from './';

/**
 * 
 * @export
 * @interface PostalAddress
 */
export interface PostalAddress {
    /**
     * 
     * @type {string}
     * @memberof PostalAddress
     */
    formattedAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof PostalAddress
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof PostalAddress
     */
    street2?: string;
    /**
     * 
     * @type {string}
     * @memberof PostalAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PostalAddress
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PostalAddress
     */
    administrativeAreaLevel4?: string;
    /**
     * 
     * @type {string}
     * @memberof PostalAddress
     */
    administrativeAreaLevel4Code?: string;
    /**
     * 
     * @type {string}
     * @memberof PostalAddress
     */
    administrativeAreaLevel3?: string;
    /**
     * 
     * @type {string}
     * @memberof PostalAddress
     */
    administrativeAreaLevel3Code?: string;
    /**
     * 
     * @type {string}
     * @memberof PostalAddress
     */
    administrativeAreaLevel2?: string;
    /**
     * 
     * @type {string}
     * @memberof PostalAddress
     */
    administrativeAreaLevel2Code?: string;
    /**
     * 
     * @type {string}
     * @memberof PostalAddress
     */
    administrativeAreaLevel1?: string;
    /**
     * 
     * @type {string}
     * @memberof PostalAddress
     */
    administrativeAreaLevel1Code?: string;
    /**
     * 
     * @type {string}
     * @memberof PostalAddress
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof PostalAddress
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PostalAddress
     */
    region?: string;
    /**
     * 
     * @type {Point}
     * @memberof PostalAddress
     */
    loc?: Point;
}

/**
 * Check if a given object implements the PostalAddress interface.
 */
export function instanceOfPostalAddress(value: object): value is PostalAddress {
    return true;
}

export function PostalAddressFromJSON(json: any): PostalAddress {
    return PostalAddressFromJSONTyped(json, false);
}

export function PostalAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostalAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
        'street': json['street'] == null ? undefined : json['street'],
        'street2': json['street2'] == null ? undefined : json['street2'],
        'city': json['city'] == null ? undefined : json['city'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'administrativeAreaLevel4': json['administrativeAreaLevel4'] == null ? undefined : json['administrativeAreaLevel4'],
        'administrativeAreaLevel4Code': json['administrativeAreaLevel4Code'] == null ? undefined : json['administrativeAreaLevel4Code'],
        'administrativeAreaLevel3': json['administrativeAreaLevel3'] == null ? undefined : json['administrativeAreaLevel3'],
        'administrativeAreaLevel3Code': json['administrativeAreaLevel3Code'] == null ? undefined : json['administrativeAreaLevel3Code'],
        'administrativeAreaLevel2': json['administrativeAreaLevel2'] == null ? undefined : json['administrativeAreaLevel2'],
        'administrativeAreaLevel2Code': json['administrativeAreaLevel2Code'] == null ? undefined : json['administrativeAreaLevel2Code'],
        'administrativeAreaLevel1': json['administrativeAreaLevel1'] == null ? undefined : json['administrativeAreaLevel1'],
        'administrativeAreaLevel1Code': json['administrativeAreaLevel1Code'] == null ? undefined : json['administrativeAreaLevel1Code'],
        'country': json['country'] == null ? undefined : json['country'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'region': json['region'] == null ? undefined : json['region'],
        'loc': json['loc'] == null ? undefined : PointFromJSON(json['loc']),
    };
}

export function PostalAddressToJSON(value?: PostalAddress | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'formattedAddress': value['formattedAddress'],
        'street': value['street'],
        'street2': value['street2'],
        'city': value['city'],
        'zipCode': value['zipCode'],
        'administrativeAreaLevel4': value['administrativeAreaLevel4'],
        'administrativeAreaLevel4Code': value['administrativeAreaLevel4Code'],
        'administrativeAreaLevel3': value['administrativeAreaLevel3'],
        'administrativeAreaLevel3Code': value['administrativeAreaLevel3Code'],
        'administrativeAreaLevel2': value['administrativeAreaLevel2'],
        'administrativeAreaLevel2Code': value['administrativeAreaLevel2Code'],
        'administrativeAreaLevel1': value['administrativeAreaLevel1'],
        'administrativeAreaLevel1Code': value['administrativeAreaLevel1Code'],
        'country': value['country'],
        'countryCode': value['countryCode'],
        'region': value['region'],
        'loc': PointToJSON(value['loc']),
    };
}

